import React from 'react';
import {
  FlexRow,
  FlexRowProps,
  formatHash,
  HashLength,
} from '@make-software/cspr-design';
import { CopyButton } from '../copy-button/copy-button';
import { HistoryLink } from '../history-link/history-link';

const shortenCsprName = (
  csprName: string,
  visibleStringLength: HashLength = HashLength.TINY
) => {
  const [name, extension] = csprName.split(/(.cspr)$/);

  const MIN_TRUNCATE_LENGTH = HashLength.TINY * 2 + 3;
  const hashLength = name.length;

  if (hashLength === HashLength.FULL || hashLength <= MIN_TRUNCATE_LENGTH) {
    return csprName;
  }

  const firstPart = name.substring(0, visibleStringLength);
  const secondPart = name.substring(hashLength - visibleStringLength);

  return `${firstPart}...${secondPart}${extension}`;
};

interface HashLinkProps {
  href: string;
  copyNotifyingStyle?: 'full' | 'tiny';
  hash: string | undefined;
  csprName?: string | null;
  hashLength?: HashLength;
  ariaDescription?: string;
  horizontalAlign?: FlexRowProps['align'];
  gap?: number;
}

export const HashLink = ({
  hash,
  href,
  copyNotifyingStyle,
  csprName,
  hashLength = undefined,
  ariaDescription,
  horizontalAlign,
  gap = 4,
}: HashLinkProps) => {
  const copiedValue = csprName || hash;

  const truncatedCsprName = csprName ? shortenCsprName(csprName) : null;
  const formattedHash = hash ? formatHash(hash, hashLength) : null;

  return (
    <FlexRow itemsSpacing={gap} align={horizontalAlign} tag={'span'}>
      <HistoryLink href={href} ariaDescription={ariaDescription}>
        {truncatedCsprName || formattedHash}
      </HistoryLink>
      <CopyButton value={copiedValue} type={copyNotifyingStyle} />
    </FlexRow>
  );
};
